// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item[data-v-272e90b6]{display:flex;margin:5px;align-items:center;justify-content:space-between;width:100%}.no-guest-label[data-v-272e90b6]{color:#999;font-style:italic;margin:10px 2px;text-align:center}.no-margin[data-v-272e90b6]{margin:0px}", ""]);
// Exports
module.exports = exports;
